import * as Actions from '../types';
import { createAction } from '../utils';
export * from './router';
export * from './release-notes.creators';
export * from './attribute-short';
export const persistInit = (persistedState) => createAction(Actions.PERSIST_INIT, persistedState);
